import { Schema } from '../../Entities/Schema.entity';
import { createSchema } from '../../Utils/CreateSchema';

export const callStartSchema: Schema = {
  ...createSchema({
    version: '1-1-0',
    description: 'The start of a lead form',
    name: 'call_start',
    properties: {
      lead_type: {
        type: 'string',
        description: 'The type of lead',
      },
      listing_id: {
        type: 'string',
        description: 'The id of the listing',
      },
      cta_location: {
        type: 'string',
        description: 'The location of the CTA (leasing page, pdp, etc.)',
      },
    },
    required: ['lead_type', 'listing_id', 'cta_location'],
  }),
};
